<template lang="html">
  <b-navbar type="faded" class="showLargeScreenOnly d-flex justify-content-between p-4 h-80px">
    <div class="d-flex">
      <b-navbar-brand href="#" class="py-4 p-xl-3">
        <img :src="imgVarsLong" @click="loadAccueil" :alt="$t('common.headbandLogoLong')" class="heritage-web-header largescreen">
        <!--<img :src="imgVarsShort" @click="loadAccueil" alt="MoneyRoad" class="heritage-web-header middlescreen">-->
      </b-navbar-brand>
      <b-navbar-nav class="m-auto" fill :key="resetMenu">
        <template v-for="(item, id) in filteredMenu">
          <b-nav-item-dropdown v-if="item.list && hasOneRight(item.list)" :key="'nav-item-dropdown-menu-id-' + id" @mouseover="autoDropdown(true, 'dropdown' + id)" @mouseleave="autoDropdown(false, 'dropdown' + id)" :ref="'dropdown' + id" class="h5 font-weight-bold dropDownInnerWebHeader p-1 p-xl-2 pr-xl-4 mt-3" toggle-class="text-menu" :text="$t(item.title)">
            <b-dropdown-group>
              <b-dropdown-item v-for="subitem in filterItems(item.list)"
                               class="dropdown-item-web-header"
                               :class="subitem.id === 0 ? 'subItemMenuWebHeader' : 'subItemTextWebHeader'"
                               :key="subitem.id" @click="getClicked(subitem)">
                {{ $t(subitem.title) }}
                <span v-if="!subitem.link" class="disabled ml-1">{{ $t('common.dsbld') }}</span>
              </b-dropdown-item>
            </b-dropdown-group>
          </b-nav-item-dropdown>
          <b-nav-item :disabled="isDisabledItem(item)" v-else-if="!item.list && item.enabled"
            class="h5 text-menu subItemTextOnlyWebHeader p-1 p-xl-2 pr-xl-4 mt-3 font-weight-bold"
            :class="{selectedMenuItemWebHeader: selectedMenu === item.link}"
            :key="'nav-item-menu-id-' + id"
            link-classes="subItemLink"
            @click="getClicked(item)">
            {{ $t(item.title) }}
            <span v-if="!item.link" class="disabled ml-1">{{ $t('common.dsbld') }}</span>
            <!--DRO 03/07/2023 : Commenté l'attribut 'style'. Enlever les classes et remettre le style si nécessaire-->
            <div v-if="item.link == selectedMenu" class="border-success border-bottom pt-2" commented_style="border-bottom:1px solid var(--actionButtonColorBlue); padding-top:10px;"></div>
            <div v-else class="opacity-0 border-bottom pt-2" commented_style="padding-top:10px"></div>
          </b-nav-item>
        </template>
      </b-navbar-nav>
    </div>

    <!-- Right Panel (user account information) -->
    <div class="d-flex align-items-center pl-1">
      <b-navbar-nav fill class="mx-0 mx-lg-3" v-if="hasCountrySelector">
        <li>
          <b-dropdown right toggle-class="border-0 p-0 bg-none m-md-2 text-dark">
            <template slot="button-content">
              {{ $t('common.ctry') }}<br>
              <span v-if="!checkedCountry">{{ $t('common.all') }}</span>
              <span v-else v-for="country in countries.filter(elem => elem.idCountry === checkedCountry)" :key="country.idCountry">
              {{ country.name }}
            </span>
              <!-- <span v-else>{{ $t('common.all') }}</span> -->
            </template>
            <b-dropdown-item
                v-if="$engine.rights.getIsSuperAdmin()"
                @click="checkedCountry = undefined; changeCountry(true)"
                class="dropdown-item-web-header">
              {{ $t('common.all') }}
            </b-dropdown-item>
            <template v-for="country in countries">
              <b-dropdown-item @click="checkedCountry = country.idCountry; changeCountry(true)" class="dropdown-item-web-header" :key="'menu-country-selector-item-' + country.idCountry">
                <span :class="checkedCountry === country.idCountry ? 'font-weight-bold text-green' : ''">{{ country.name }}</span>
              </b-dropdown-item>
            </template>
          </b-dropdown>
        </li>
      </b-navbar-nav>

      <b-navbar-nav fill class="mx-0 mx-lg-3" v-if="hasNormSelector">
        <li class="nav-item">
          <b-dropdown right toggle-class="border-0 p-0 bg-none m-md-2 text-dark">
            <template slot="button-content">
              Clearing<br>
              <span v-for="norm in norms.filter(n => n.value === checkedNorm)" :key="norm.value">{{ norm.text }}</span>
            </template>
            <b-dropdown-item v-for="norm in norms" :key="norm.value" @click="checkedNorm = norm.value; changeNorm(true)" class="dropdown-item-web-header">
              <span :class="checkedNorm === norm.value ? 'font-weight-bold text-green' : ''">{{ norm.text }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </li>
      </b-navbar-nav>

      <b-navbar-nav fill class="mx-1" @mouseover="autoDropdown(true, 'log')" @mouseleave="autoDropdown(false, 'log')">
        <b-nav-item-dropdown v-if="this.$engine.user && this.$engine.user.userAccountId !== 1" ref="log" class="logOut" toggle-class="d-flex align-items-center" right variant="link">
          <template v-slot:button-content>
            <img class="navbarProfileImage mr-2" :src="imgProfil" :alt="$t('common.profil_Image')"/>
            <div class="d-flex flex-column align-items-start">
              <span class="d-none d-xl-inline mr-2 h5 mb-0 text-menu profile-menu"> <strong> {{ companyName }} </strong> </span>
              <span class="d-none d-xl-inline mr-2 mb-0 text-menu profile-menu">  {{ userName }} </span>
            </div>
          </template>
          <b-dropdown-item @click="goToLink('/profile/')" class="subItemTextWebHeader dropdown-item-web-header">{{ $t('leftPanelTitle.my_prfl') }}</b-dropdown-item>
          <b-dropdown-item v-if="hasMultipleAccounts()" @click="activateModalProfile" class="subItemTextWebHeader dropdown-item-web-header">{{ $t('leftPanelTitle.swtch_prfl') }}</b-dropdown-item>
          <!-- <b-dropdown-item v-if="$engine.rights.rightIs('settings_consulter',true)" @click="goToLink('/settings/application/')" class="subItemTextWebHeader dropdown-item-web-header">{{ $t('Webheader.settings') }}</b-dropdown-item> -->
          <!--<b-dropdown-item @click="logout" class="subItemTextWebHeader dropdown-item-web-header">{{ this.$t('leftPanelTitle.lgout') }}</b-dropdown-item> -->
        </b-nav-item-dropdown>
      </b-navbar-nav>

      <b-navbar-nav fill class="mx-1 my-2 m-lg-2">
        <li>
          <b-button variant="primary" class="px-2 px-lg-4 d-none-max-849px text-nowrap" @click="logout">
            <span class="d-none-max-1459px"> {{ $t('leftPanelTitle.lgout') }} </span>
            <i class="d-none-min-1460px fa fa-power-off fs-14px"></i>
          </b-button>
        </li>
      </b-navbar-nav>

      <b-navbar-nav fill class="mx-0 mx-lg-3">
        <li>
          <b-dropdown right toggle-class="border-0 p-0 bg-none m-md-2 text-dark" v-model="language">
            <template slot="button-content">
              <img class="flag-nav" :src="language === 'FR' ? logoFlagFR : logoFlagEN" :alt="$t('common.logo_language')" /><span class="d-none-max-1459px mr-1">{{ labelLanguage }}</span>
            </template>
            <b-dropdown-item v-for="option in options" :key="option.value" class="dropdown-item-web-header" @click="languageCountry(option.value)">
              <img class="flag-nav" v-if="option.value === 'FR'" :src="logoFlagFR" :alt="$t('common.logo_fr')"/>
              <img class="flag-nav" v-else :src="logoFlagEN" :alt="$t('common.logo_en')"/>
              <span>{{option.text}}</span>
            </b-dropdown-item>
          </b-dropdown>
        </li>
      </b-navbar-nav>
    </div>
  </b-navbar>
</template>

<script>
import ProfileImage from './../../assets/static/images/image-profile2.png'
import FlagFRImage from './../../assets/static/images/fr.png'
import FlagENImage from './../../assets/static/images/gb.png'
import {loadPage, reloadPage2} from './../../helpers/routing'
import CompanyTheme from './../../helpers/companyTheme.json'
import Services from '@/helpers/services'
import design from '@/design/design.json'

/* Remettre dans menu.json après la démo du 26/02 (quand on pourra prendre le temps
* de mettre des droits sur les fournisseurs) :
{
  "id": 7,
  "title": "Homepage.create_supplier",
  "link": "/suppliers/create/",
  "enabled": true,
  "service": 8
},
{
  "id": 8,
  "title": "Webheader.my_suppliers",
  "link": "/inbox/",
  "enabled": true,
  "service": 8
},
{
  "id": 9,
  "title": "Webheader.verifications",
  "link": "/verifications/SIREN/",
  "enabled": true,
  "service": 8
} **/
/* Barre de navigation sur grands écran (ordinateurs), et liens contenus dans celle-ci */
export default {
  name: 'WebHeader',
  props: {
    context: {
      default: 'generic',
      type: String
    }
  },
  data () {
    return {
      accountType: 0,
      checkedCountry: 0,
      checkedNorm: 0,
      companyId: 0,
      companyName: '',
      companyTheme: CompanyTheme,
      countries: [],
      design: design.menu,
      language: '',
      languageLabel: 'Français',
      lastSetNorm: 0,
      logoProfile: ProfileImage,
      logoFlagFR: FlagFRImage,
      logoFlagEN: FlagENImage,
      menu: {},
      menuLinkList: null,
      norms: [],
      options: [],
      resetMenu: false,
      selectedMenu: '',
      userName: '',
    }
  },
  computed: {
    filteredMenu () {
      let that = this
      return this.menu.filter(item => !that.isDisabledItem(item))
    },
    hasAtLeastTwoRightNorm () {
      let rightNormCounter = 0
      if (this.hasRightHRTP === true) {
        rightNormCounter += 1
      }
      if (this.hasRightPSD2 === true) {
        rightNormCounter += 1
      }
      if (this.hasRightSRTP === true) {
        rightNormCounter += 1
      }
      return rightNormCounter >= 2
    },
    hasCountrySelector () {
      return Object.keys(this.$engine.rights.getCountries()).length > 1
    },
    hasNormSelector () {
      return false && this.norms.length >= 1 && !this.$engine.rights.rightIs('super_admin', true)
    },
    hasRightHRTP () {
      let currentRights = this.$engine.rights.getAll()
      let rightHRTPFound = false
      if (currentRights && Object.entries(currentRights).length) {
        Object.entries(currentRights).forEach((right) => {
          if (right[0].includes('_hrtp') && right[1] === true) {
            rightHRTPFound = true
          }
        })
      }
      return rightHRTPFound
    },
    hasRightPSD2 () {
      let currentRights = this.$engine.rights.getAll()
      let rightPSD2Found = false
      if (currentRights && Object.entries(currentRights).length) {
        Object.entries(currentRights).forEach((right) => {
          if (right[0].includes('_psd2') && right[1] === true) {
            rightPSD2Found = true
          }
        })
      }
      return rightPSD2Found
    },
    hasRightSRTP () {
      let currentRights = this.$engine.rights.getAll()
      let rightSRTPFound = false
      if (currentRights && Object.entries(currentRights).length) {
        Object.entries(currentRights).forEach((right) => {
          if (right[0].includes('_srtp') && right[1] === true) {
            rightSRTPFound = true
          }
        })
      }
      return rightSRTPFound
    },
    imgVarsLong () {
      return this.design.headbandLogoLong
    },
    imgVarsShort () {
      return this.design.headbandLogoShort
    },
    imgProfil () {
      return this.design.headbandProfilePic
    },
    labelLanguage () {
      let lang = this.language
      let langOpt = this.options.filter(elem => elem.value.toLowerCase() === lang.toLowerCase())
      let label = this.$t('lang.french')
      if (langOpt.length) {
        label = langOpt[0].text
      }
      return label
    }
  },
  created () {
    this.language = this.$i18n.locale.toUpperCase()
    this.checkedCountry = this.$engine.rights.getCurrentCountry().idCountry
    this.countries = Object.entries(this.$engine.rights.getCountries()).map(([key, value]) => ({ idCountry: Number(key), ...value }));
    if (this.hasRightSRTP) {
      this.norms.push({value: 1, text: this.$t('Webheader.norm_srtp')})
    }
    if (this.hasRightHRTP) {
      this.norms.push({value: 2, text: this.$t('Webheader.norm_hrtp')})
    }
    if (this.hasRightPSD2) {
      this.norms.push({value: 3, text: this.$t('Webheader.norm_psd2')})
    }
    this.options = [
      { value: 'FR', text: this.$t('lang.french')},
      { value: 'EN', text: this.$t('lang.english')}
    ]
    if (this.context && this.context !== 'generic') {
      this.menuLinkList = require('./data/menu_' + this.context + '.json')
    } else {
      this.menuLinkList = require('./data/menu.json')
    }
    if (this.$engine.user.get().name != null) {
      this.companyName = this.$engine.user.get().name
    }
    this.getUsername()
    this.accountType = this.$engine.user.get().type
    this.companyId = this.$engine.user.get().id
    this.setMenuItems()
    this.setCheckedCountry()
    // this.setCheckedNorm()
    this.$bus.$on('refresh-cache-menu', () => {
      this.companyName = this.$engine.user.get().name
      this.accountType = this.$engine.user.get().type
      this.setMenuItems()
    })
    let that = this
    this.$bus.$off('reset-selected-menu')
    this.$bus.$on('reset-selected-menu', function () {
      that.selectedMenu = ''
      let elem = document.getElementsByClassName('selectedMenuItemWebHeader').item(0)
      if (elem) {
        elem.classList.remove('selectedMenuItemWebHeader')
      }
      that.resetMenu = !that.resetMenu
    })
    this.$bus.$on('switch-selected-menu', function(newUrl) {
      that.selectedMenu = newUrl
    })
    if (this.$engine.auth.isAuth() && this.$f7.getCurrentView().url === '/login/') {
      this.selectedMenu = '/home/'
    } else {
      this.verifyCurrentView()
    }
    this.canUserSeePage()
  },
  mounted () {
  },
  methods: {
    activateModalProfile () {
      this.$f7.popup('#switch-profile-true')
    },
    autoDropdown (value, id) {
      Object.keys(this.$refs).forEach((item) => {
        if (item === id) {
          if (this.$refs[item][0]) {
            this.$refs[item][0].visible = value
          } else {
            this.$refs[item].visible = value
          }
        }
      })
    },
    canShowSpecific (subItem) {
      if ((subItem.link === '/rights/profiles/') && this.$engine.user.get().type === '2') {
        return false
      }
      return true
    },
    canUserSeePage () {
      let currentPage = {}
      let that = this
      this.menu.forEach((page) => {
        if (page.link === this.selectedMenu) {
          currentPage = page
          return
        } else if (page.list && page.list.length > 0) {
          page.list.forEach((subpage) => {
            if (subpage.link === this.selectedMenu) {
              currentPage = subpage
              return
            }
          })
        }
      })
      if (Object.keys(currentPage).length === 0) {
        return
      } else {
        if (this.isDisabledItem(currentPage)) {
          reloadPage2(that, '/home/')
          that.selectedMenu = '/home/'
        }
      }
    },
    changeCountry (isClick = false) {
      let that = this
      if (this.checkedCountry === this.$engine.rights.getCurrentCountry().idCountry) {
        return
      } else {
        this.$engine.rights.setCurrentCountry(this.checkedCountry)
        reloadPage2(that, that.selectedMenu)
        if (isClick === true) {
          this.$bus.$emit('reset-webheader')
          if (that.selectedMenu === '/profile/' || that.selectedMenu === '/settings/application/') {
            that.goToLink(that.selectedMenu)
          }
        }
      }
    },
    changeNorm (isClick = false) {
      let currentPage = {}
      let that = this
      this.menu.forEach((page) => {
        if (page.link === this.selectedMenu) {
          currentPage = page
          return
        } else if (page.list && page.list.length > 0) {
          page.list.forEach((subpage) => {
            if (subpage.link === this.selectedMenu) {
              currentPage = subpage
              return
            }
          })
        }
      })
      if (this.checkedNorm === this.lastSetNorm) {
        return
      } else {
        this.$engine.user.setUserNorm(this.checkedNorm.toString(10))
        this.lastSetNorm = this.checkedNorm
        if (currentPage.norm_disable ||
          this.selectedMenu === '/home/' ||
          this.selectedMenu === '/settings/rtpSettings/' ||
          this.selectedMenu === '/payments/newPayments/' ||
          this.selectedMenu === '/history/' ||
          this.selectedMenu === '/routing/message' ||
          this.selectedMenu === '/routing/configurationList/WEBSERVICE') {
          reloadPage2(that, that.selectedMenu)
        }
        if (isClick === true) {
          this.$bus.$emit('reset-webheader')
          if (that.selectedMenu === '/profile/' || that.selectedMenu === '/settings/application/') {
            that.goToLink(that.selectedMenu)
          }
        }
      }
    },
    filterItems (itemList) {
      let that = this
      return itemList.filter(subitem => subitem.enabled && that.canShowSpecific(subitem) && !that.isDisabledItem(subitem))
    },
    getBackground () {
      if (this.companyTheme[this.companyId] && this.companyTheme[this.companyId].background) {
        return 'background: ' + this.companyTheme[this.companyId].background
      }
    },
    getClicked (subitem) {
      switch (subitem.link) {
        case '/directPayments/creation/':
          this.$bus.$emit('service:change', 'Direct Payments')
          this.$bus.$emit('direct-inbox-filtered', 1)
          this.$engine.user.changeService(this.$engine.services.getServiceById(Services.DIRECTPAYMENTS))
          this.$engine.user.currentService.id = Services.DIRECTPAYMENTS
          break
        case '/payments/newPayments/':
          this.$bus.$emit('service:change', 'Payments')
          this.$bus.$emit('direct-debit-filtered', 1)
          this.$engine.user.changeService(this.$engine.services.getServiceById(Services.PAYMENTS))
          this.$engine.user.currentService.id = Services.PAYMENTS
          break
        case '/directDebit/creation/':
          this.$bus.$emit('service:change', 'Direct Debit')
          this.$bus.$emit('inbox-filtered', 1)
          this.$engine.user.changeService(this.$engine.services.getServiceById(Services.DIRECTDEBIT))
          this.$engine.user.currentService.id = Services.DIRECTDEBIT
          break
        case '/businessDocument/sendForm/':
        case '/businessDocument/requestForm/':
          this.$bus.$emit('service:change', 'Business Documents')
          this.$bus.$emit('inbox-filtered', 1)
          this.$engine.user.changeService(this.$engine.services.getServiceById(Services.DOCUMENTSERVICE))
          this.$engine.user.currentService.id = Services.DOCUMENTSERVICE
          break
        case '/suppliers/create/':
          this.$bus.$emit('service:change', 'Suppliers')
          this.$bus.$emit('inbox-filtered', 1)
          this.$engine.user.changeService(this.$engine.services.getServiceById(Services.SUPPLIERS))
          this.$engine.user.currentService.id = Services.SUPPLIERS
          break
        case String(subitem.link.match('^/inbox/.*')):
          switch (subitem.service) {
            case 1:
              this.$bus.$emit('service:change', 'Payments')
              this.$bus.$emit('direct-debit-filtered', 1)
              this.$engine.user.changeService(this.$engine.services.getServiceById(Services.PAYMENTS))
              this.$engine.user.currentService.id = Services.PAYMENTS
              break
            case 2:
              this.$bus.$emit('service:change', 'Direct Debit')
              this.$bus.$emit('inbox-filtered', 1)
              this.$engine.user.changeService(this.$engine.services.getServiceById(Services.DIRECTDEBIT))
              this.$engine.user.currentService.id = Services.DIRECTDEBIT
              break
            case 6:
              this.$bus.$emit('service:change', 'Direct Payments')
              this.$bus.$emit('direct-inbox-filtered', 1)
              this.$engine.user.changeService(this.$engine.services.getServiceById(Services.DIRECTPAYMENTS))
              this.$engine.user.currentService.id = Services.DIRECTPAYMENTS
              break
            case 7:
              this.$bus.$emit('service:change', 'Business Documents')
              this.$bus.$emit('inbox-filtered', 1)
              this.$engine.user.changeService(this.$engine.services.getServiceById(Services.DOCUMENTSERVICE))
              this.$engine.user.currentService.id = Services.DOCUMENTSERVICE
              break
            case 8:
              this.$bus.$emit('service:change', 'Suppliers')
              this.$bus.$emit('inbox-filtered', 1)
              this.$engine.user.changeService(this.$engine.services.getServiceById(Services.SUPPLIERS))
              this.$engine.user.currentService.id = Services.SUPPLIERS
              break
            case 9:
              this.$bus.$emit('service:change', 'Verifications')
              this.$bus.$emit('inbox-filtered', 1)
              this.$engine.user.changeService(this.$engine.services.getServiceById(Services.VERIFICATIONS))
              this.$engine.user.currentService.id = Services.VERIFICATIONS
              break
            default:
            /*  "Tous les services", à reprendre plus tard
            {id: 4, title: 'Webheader.all_usages', link: '/inbox/'} */
              break
          }
          break
        default:
          break
      }
      let that = this
      this.selectedMenu = subitem.link
      reloadPage2(that, subitem.link)
    },
    getLargeLogo () {
      if (this.companyTheme[this.companyId] && this.companyTheme[this.companyId].logoLarge) {
        return './../../assets/static/images/logo/' + this.companyTheme[this.companyId].logoLarge
      } else {
        return require('./../../assets/static/images/logo/moneyroad_white_green.png')
      }
    },
    getMiddleLogo () {
      if (this.companyTheme[this.companyId] && this.companyTheme[this.companyId].logoMiddle) {
        return './../../assets/static/images/logo/' + this.companyTheme[this.companyId].logoMiddle
      } else {
        return require('./../../assets/static/images/logo/mrlogo.png')
      }
    },
    getUsername () {
      let info = this.$engine.accounts.get()
      if (!info || !info[0] || !info[0].userAccts) return
      let userAccounts = info[0].userAccts
      let userAccountId = info[0].userAccountId
      userAccounts = userAccounts.filter((account) => account.id === userAccountId)
      if (userAccounts.length) this.updateUsername(userAccounts)
    },
    goToLink (linkToGo) {
      this.selectedMenu = linkToGo
      this.$f7.mainView.router.load({url: linkToGo, reload: true})
    },
    goToLoginPage () {
      var that = this
      loadPage(that, {url: '/login/'})
    },
    hasMultipleAccounts () {
      let accounts = this.$engine.accounts.get()
      let diffAccounts = []
      accounts.forEach(account => {
        if (!diffAccounts.includes(account.id)) {
          diffAccounts.push(account.id)
        }
      })
      return diffAccounts.length > 1
    },
    hasOneRight (itemList) {
      let that = this
      return itemList.filter(item => {
        return !that.isDisabledItem(item)
      }).length
    },
    isDisabledItem (item) {
      if (item && !item.enabled) {
        return true
      }
      if (item.super_admin_menu && (!this.$engine.rights.getIsSuperAdmin() || this.$engine.rights.getCurrentCountry().idCountry)) {
        return true
      }
      if (item && item.right_disable && item.right_disable.right && item.right_disable.right.length) { // If item has a right value
        if (Array.isArray(item.right_disable.right)) {
          let nbRights = 0
          for (let i = 0; i < item.right_disable.right.length;i++) {
            nbRights += !this.$engine.rights.rightIs(item.right_disable.right[i], item.right_disable.state) ? 1 : 0
          }
          return item.right_disable.mode === 'AND' ? nbRights < item.right_disable.right.length : nbRights === 0
        } else {
          if (item.right_disable.right === 'rights_profile_consult') {
            return this.$engine.user.get().id === this.$engine.user.get()
            ? this.$engine.rights.rightIs('rights_admin_consulter', item.right_disable.state)
            : this.$engine.rights.rightIs(item.right_disable.right, item.right_disable.state)
          }
        }
        // Return true if the right has the same state as the disabling state
        // if (item && item.norm_disable && this.$engine.user.getUserNorm()) {
        //   if (this.$engine.user.getUserNorm() === '1') {
        //     return this.$engine.rights.rightIs(item.norm_disable.SRTP.right, item.norm_disable.SRTP.state)
        //   } else if (this.$engine.user.getUserNorm() === '2') {
        //     return this.$engine.rights.rightIs(item.norm_disable.HRTP.right, item.norm_disable.HRTP.state)
        //   } else if (this.$engine.user.getUserNorm() === '3') {
        //     return this.$engine.rights.rightIs(item.norm_disable.PSD2.right, item.norm_disable.PSD2.state)
        //   }
        // } else {
        // }
        return this.$engine.rights.rightIs(item.right_disable.right, item.right_disable.state)
      }
      return false
    },
    languageCountry (language) {
      this.language = language
      if (language === 'EN') {
        this.$i18n.locale = 'en'
      } else {
        this.$i18n.locale = 'fr'
      }
      this.options = [
        { value: 'FR', text: this.$t('lang.french')},
        { value: 'EN', text: this.$t('lang.english')}
      ]
    },
    loadAccueil () {
      var that = this
      this.selectedMenu = '/home/'
      // loadPage(that, {url: '/home/' + that.context})
      loadPage(that, {url: '/home/'})
    },
    logout () {
      this.$bus.emit('logout')
    },
    setCheckedCountry () {
      this.checkedCountry = this.$engine.rights.getCurrentCountry().idCountry
    },
    setCheckedNorm () {
      if (this.hasRightSRTP && !this.hasRightHRTP && !this.hasRightPSD2) {
        this.checkedNorm = 1
        this.changeNorm()
      } else if (!this.hasRightSRTP && this.hasRightHRTP && !this.hasRightPSD2) {
        this.checkedNorm = 2
        this.changeNorm()
      } else if (!this.hasRightSRTP && !this.hasRightHRTP && this.hasRightPSD2) {
        this.checkedNorm = 3
        this.changeNorm()
      } else if (this.hasAtLeastTwoRightNorm) {
        this.$engine.user.getUserNorm()
        let normAnswer = this.$engine.user.getUserNorm()
        if ((normAnswer === '1' && this.hasRightSRTP) || (normAnswer === '2' && this.hasRightHRTP) || (normAnswer === '3' && this.hasRightPSD2)) {
          normAnswer === '1' ? this.checkedNorm = 1 : normAnswer === '2' ? this.checkedNorm = 2 : this.checkedNorm = 3
        } else {
          let randomNumber = Math.floor(Math.random() * 3);
          if (randomNumber === 0) {
            this.checkedNorm = 1
          } else if (randomNumber === 1) {
            this.checkedNorm = 2
          } else {
            this.checkedNorm = 3
          }
        }
        this.changeNorm()
      } else {
        if (this.$engine.user.getUserNorm()) {
          this.$engine.user.deleteUserNorm()
        }
        return
      }
    },
    setMenuItems () {
      this.menu = this.menuLinkList['linkContent']
      // compter le nombre de pages dispo
      let nbPage = 0
      let link = ''
      let that = this
      this.menu.forEach((item) => {
        if (item.list && item.list.length) {
          if (that.hasOneRight(item.list) && !that.isDisabledItem(item)) {
            item.list.forEach((subitem) => {
              if (subitem.enabled && that.canShowSpecific(subitem) && !that.isDisabledItem(subitem)) {
                nbPage++
                link = subitem.link
              }
            });
          }
        } else if (item.enabled && !that.isDisabledItem(item)) {
          nbPage++
          link = item.link
        }
      })
      if (nbPage === 1 ) {
        reloadPage2(that, link)
      }
    },
    updateUsername (userAccount) {
      this.userAccountInfo = userAccount
      this.userName = this.userAccountInfo[0].name
    },
    verifyCurrentView () {
      let pageExistsInMenu = false
      this.menu.forEach((page) => {
        if (page.link === this.$f7.getCurrentView().url) {
          pageExistsInMenu = true
          return
        } else if (page.list && page.list.length > 0) {
          page.list.forEach((subpage) => {
            if (subpage.link === this.$f7.getCurrentView().url) {
              pageExistsInMenu = true
              return
            }
          })
        }
      })
      if (pageExistsInMenu === true || this.$f7.getCurrentView().url === '/home/' || this.$f7.getCurrentView().url === '/profile/' || this.$f7.getCurrentView().url === '/settings/application/') {
        this.selectedMenu = this.$f7.getCurrentView().url
      } else {
        //Pour le cas des détails Dashboard par exemple DRO 02/08/2024
        this.selectedMenu = this.$f7.mainView.history[this.$f7.mainView.history.length - 2]
      }
    }
  }

}
</script>
